import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layout
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './components/page';
import About from './components/about/page';
import Contact from './components/contact/page';
import Products from './components/products/page';
import ProductDetail from './components/products/[id]/page';
import Blog from './components/blog/page';
import Checkout from './components/checkout/page';
import Login from './components/login/page';
import Signup from './components/signup/page';
import Admin from './components/admin/page';
import AdminOrders from './components/admin/orders/page';
import AdminProducts from './components/admin/products/add/page';
import AdminAnalytics from './components/admin/analytics/page';
import Privacy from './components/privacy/page';
import Terms from './components/terms/page';
import Shipping from './components/shipping/page';
import MyOrders from './components/orders/page';
import NotFound from './components/not-found';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:id" element={<ProductDetail />} />
        <Route path="blog" element={<Blog />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="shipping" element={<Shipping />} />
        <Route path="my-orders" element={<MyOrders />} />
        
        {/* Admin Routes */}
        <Route path="admin" element={<Admin />}>
          <Route index element={<AdminAnalytics />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="products/add" element={<AdminProducts />} />
          <Route path="analytics" element={<AdminAnalytics />} />
        </Route>
        
        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </>
  );
}

export default App;